module.exports = __webpack_public_path__ + "static/img/semi-heavy-horse-orange.49c362a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-horse-orange.svg
// module id = cG7E
// module chunks = 74